import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import aboutBg from "../../images/bg/about-bg.png";

// About images (3–4 images)
import img01 from "../../images/about/photohzt.png";
import img02 from "../../images/about/Videohzt.jpg";
import img03 from "../../images/about/laptophzt.png";


const AboutSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-about-img-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  const aboutImages = [img01, img02, img03];

  return (
    <section className="about pt-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">¿Quiénes somos?</span>
          <h2 className="title">
            Transformamos tus ideas
            en contenido audiovisual            
            que supera todo límite.{" "}
            
          </h2>
        </div>
      </div>

      {/* ✅ One single marquee with all 3 images */}
      <div className="xb-about-img-wrap bg_img wow">
        <Marquee speed={40} gradient={false} pauseOnHover={false}>
{aboutImages.map((img, idx) => (
  <div key={idx} className="xb-about-img-item">
    <Link className="xb-img about-service-link" to="/service">
      <img src={img} alt={`about-${idx + 1}`} />
    </Link>
  </div>
))}
        </Marquee>
      </div>
    </section>
  );
};

export default AboutSection;
